import { Box, Divider, Switch, Text } from "@mantine/core";
import React, { useEffect, useState } from "react";
import useStyles from "./style";
import ActionButtons from "./ActionButtons";
import { initialAdminPermissions, initialStaffPermissions } from "../../utils";
import { useSelector } from "react-redux";

/**
 * Component to manage staff roles and display permissions.
 * @param {Object} props
 * @param {string} props.activeTab - Contains the selected staff's data info.
 * @param {Object} props.data - Contains the selected staff's data info.
 * @param {Object} props.mode - Contains the mode of the component like view or edit.
 * @param {Object} props.role - Contains the current role of the staff.
 * @param {Function} props.setRole - Function to set the role of the staff.
 * @param {Function} props.handleSave - Function to handle save action.
 * @param {Function} props.handleCancel - Function to handle cancel action.
 * @param {String} props.activeTab - Contains the selected tab.
 * @param {Boolean} props.roleError - Function to handle cancel action.
 */

export const StaffRolePermissionTab = ({
  data,
  mode,
  role,
  setRole,
  handleSave,
  handleCancel,
  activeTab,
  roleError,
  userpermissions,
  setUserPermissions,
}) => {
  const { classes, cx } = useStyles();
  const tabs = ["roles", "permissions"];
  const [subActiveTab, setActiveTab] = useState("roles");

const billing = useSelector((state) => {
    return state.featureFlags.billing;
  });

  
  // Initialize role based on valid values
  useEffect(() => {
    const validRoles = ["admin", "staff"];
    if (validRoles.includes(data?.role)) {
      setRole(data.role);
    }

    if (data?.permissions && typeof data.permissions === "object") {
      // Merge defaults with backend data (in case some keys are missing)
      const mergedPermissions = {
        ...userpermissions,
        ...data.permissions,
      };
      setUserPermissions(mergedPermissions);
    }
  }, [data?.role]);

  // Handle role toggle
  const handleRoleChange = (newRole) => {
    if (role !== newRole) {
      setRole(newRole);
      if (newRole === "admin") {
        setUserPermissions(initialAdminPermissions);
      } else {
        setUserPermissions(initialStaffPermissions);
      }
    }
  };
  const handlePermissionToggle = (key) => {
    setUserPermissions((prev) => ({
      ...prev,
      [key]: !prev[key],
    }));
  };

  // Capitalize utility
  const capitalize = (str) => str.charAt(0).toUpperCase() + str.slice(1);
const filteredPermissions = Object.entries(userpermissions).filter(
    ([key]) => key !== "billing" || billing
  );


  const Roles = () => {
    return (
      <Box className={classes.rolesContainer}>
        {["admin", "staff"].map((roleType) => (
          <Switch
            key={roleType}
            size="md"
            color="yellow"
            disabled={mode === "view"}
            label={capitalize(roleType)}
            labelPosition="left"
            checked={role === roleType}
            onChange={() => handleRoleChange(roleType)}
            className={classes.swites}
          />
        ))}
      </Box>
    );
  };

  const Permissions = () => {
    return (
      <Box className={classes.permissionsGrid}>
        <Box className={classes.permissioncolumn}>
          <Text fw={600} mb={10}></Text>
          {/* Empty or placeholder content to align with Permissions column */}
        </Box>
        <Box className={classes.permissioncolumn}>
          {/* {Object.entries(userpermissions).map(([key, value]) => ( */}
          {filteredPermissions?.map(([key, value]) => (
            <Switch
              key={key}
              size="md"
              color="yellow"
              disabled={mode === "view"}
              label={capitalize(key)}
              labelPosition="right"
              checked={value}
              onChange={() => handlePermissionToggle(key)}
              className={classes.Permissionswites}
            />
          ))}
        </Box>
      </Box>
    );
  };

  return (
    <Box>
      <Box className={classes.tabContainer}>
        {tabs?.map((tab) => (
          <Text
            key={tab}
            className={cx(classes.tab, {
              [classes.activeTab]: subActiveTab === tab,
              // [classes.disabledTab]: tab === "permissions",
            })}
            onClick={() => setActiveTab(tab)}
            transform="capitalize"
            // style={
            //   tab === "permissions"
            //     ? { cursor: "not-allowed", opacity: 0.5 }
            //     : {}
            // }
          >
            {tab}
          </Text>
        ))}
      </Box>

      <Box className={classes.staffInfoContainer}>
        <Box px={20} pb={20}>
          {subActiveTab === "roles" && <Roles />}
          {subActiveTab === "permissions" && <Permissions />}
        </Box>

        {mode === "view" ? null : (
          <>
            <Box>
              <Divider my={10} />
              <ActionButtons
                onCancel={handleCancel}
                onSave={handleSave}
                type="submit"
                activeTab={activeTab}
              />
            </Box>
          </>
        )}
      </Box>
    </Box>
  );
};
